// @flow
import React, { type Children } from 'react'
import './styles.scss'

type Props = { children: Children, side: 'right' | 'left' }

export const SideElement = ({ children, side = 'left' }: Props) => {
  return <aside className={`ta ${side} sideelement`}>{children}</aside>
}
